import { wrapper, createApiClient, Result, ApiError } from "../base";
import AnnotatedEventDO = App.Data.AnnotatedEventDO;
import UpsertAnnotatedEventDTO = App.Data.UpsertAnnotatedEventDTO;

const basePath = `annotated-events`;
const baseClient = createApiClient();

export type GetAnnotatedEventsParams = {
	created_by_user_id?: number;
	applies_to_subject_date?: boolean;
	applies_to_measure_date?: boolean;
	category_ids?: (number | null)[];
};

export type GetAnnotatedEventsParamsWithDate = GetAnnotatedEventsParams & {
	from: Date;
	to: Date;
};

function formatEventForApi(event: UpsertAnnotatedEventDTO): object {
	return {
		...event,
		from: event.from.toISOString(),
		to: event.to.toISOString(),
	};
}

export default class {
	get(
		params: GetAnnotatedEventsParams | GetAnnotatedEventsParamsWithDate = {}
	): Promise<Result<AnnotatedEventDO[], ApiError>> {
		const query = {
			"filter[created_by_user_id]": params.created_by_user_id,
			"filter[applies_to_subject_date]": params.applies_to_subject_date,
			"filter[applies_to_measure_date]": params.applies_to_measure_date,
			"filter[category_id]": params.category_ids
				? params.category_ids.map((categoryId) =>
						categoryId === null ? "null" : categoryId
				  )
				: undefined,
		};

		if ("from" in params) {
			query["filter[in_range]"] =
				params.from.toISOString() + "," + params.to.toISOString();
		}

		return wrapper(baseClient.get(`${basePath}`, { params: query }));
	}

	create(
		event: UpsertAnnotatedEventDTO
	): Promise<Result<AnnotatedEventDO, ApiError>> {
		return wrapper(baseClient.post(`${basePath}`, formatEventForApi(event)));
	}

	update(
		event: UpsertAnnotatedEventDTO
	): Promise<Result<AnnotatedEventDO, ApiError>> {
		return wrapper(
			baseClient.patch(`${basePath}/${event.id}`, formatEventForApi(event))
		);
	}

	delete(id: number): Promise<Result<boolean, ApiError>> {
		return wrapper(baseClient.delete(`${basePath}/${id}`));
	}
}
